import type { HfDynamicFieldComponentProps } from '@myosh/odin-components';
import { OdinController } from '@myosh/odin-components';
import type { LinkedRecordResult } from '../../../@types/linked-records-field';
import type { LinkedRecordsProps } from './linked-records.component';
import LinkedRecords from './linked-records.component';

interface HfLinkedRecordsProps
  extends HfDynamicFieldComponentProps<Array<LinkedRecordResult>, Array<string>>,
    Omit<LinkedRecordsProps, 'name'> {}

export default function HfLinkedRecords(props: HfLinkedRecordsProps) {
  const { name, control, value, onChange, ...rest } = props;
  return (
    <OdinController
      name={name as string}
      control={control}
      defaultValue={value}
      onChange={onChange}
      render={({ field: { onChange: fieldOnChange, value: fieldValue }, fieldState: { error } }) => (
        <LinkedRecords {...rest} value={fieldValue} onChange={fieldOnChange} error={error?.message} />
      )}
    />
  );
}
